// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Stack, Typography } from '@mui/material';
import { PropsWithChildren } from 'react';

interface Props {
  /**
   * The title of the row.
   */
  title: string;

  /**
   * The subtitle of the row.
   */
  subtitle: string;
}

/**
 * Renders a title and subtitle with children in a row. On smaller screen
 * sizes, the children will be stacked below the title and subtitle.
 */
export function FormCardRow(props: PropsWithChildren<Props>) {
  return (
    <Stack
      useFlexGap
      direction={{ xs: 'column', md: 'row' }}
      padding={2}
      spacing={2}
      justifyContent="space-between"
    >
      <Stack>
        <Typography variant="subtitle2">{props.title}</Typography>
        <Typography variant="body2" color="text.secondary">
          {props.subtitle}
        </Typography>
      </Stack>
      {props.children}
    </Stack>
  );
}
